var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35399 5.07335L4.849 6.93746C4.59848 7.04113 4.60108 7.39698 4.85317 7.4969L9.37701 9.29086C9.77451 9.4485 10.2172 9.4485 10.6146 9.29086L15.1385 7.4969C15.3905 7.39698 15.3932 7.04113 15.1426 6.93746L10.6377 5.07335C10.2267 4.90328 9.76495 4.90328 9.35399 5.07335Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3972 10.2705V14.752C10.3972 14.9652 10.6121 15.1112 10.8102 15.0326L15.8512 13.076C15.9662 13.0303 16.0417 12.9192 16.0417 12.7954V8.31383C16.0417 8.10067 15.8268 7.95471 15.6286 8.03326L10.5877 9.98991C10.4727 10.0355 10.3972 10.1467 10.3972 10.2705Z",
    fill: "#26B5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22005 10.5018L7.72401 11.2241L7.57211 11.2975L4.41407 12.8107C4.21388 12.9073 3.95837 12.7614 3.95837 12.539V8.3327C3.95837 8.25224 3.99963 8.18278 4.05495 8.13046C4.07804 8.10731 4.10419 8.08826 4.13138 8.07316C4.20685 8.02788 4.31449 8.01579 4.40601 8.05199L9.19492 9.94942C9.43834 10.046 9.45746 10.3871 9.22005 10.5018Z",
    fill: "#ED3049"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22006 10.5018L7.72403 11.2241L4.05496 8.13046C4.07805 8.10731 4.10421 8.08826 4.13139 8.07316C4.20686 8.02788 4.3145 8.01579 4.40602 8.05199L9.19493 9.94942C9.43835 10.046 9.45747 10.3871 9.22006 10.5018Z",
    fill: "currentColor",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtable);
export default __webpack_public_path__ + "static/media/airtable.d004afd6ffa6a71ab3ffa14fc949317a.svg";
export { ForwardRef as ReactComponent };